import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '@material-ui/core';

import { Network } from 'api/public';

type Props = {
  network: Network;
};

const PublicShareSuccessMessage: FC<Props> = ({ network }) => {
  const { t } = useTranslation();

  const networkTitles = {
    [Network.Twitter]: t('admin:twitter'),
    [Network.Linkedin]: t('admin:linkedin'),
    [Network.Facebook]: t('admin:facebook'),
  };

  function renderSuccessLink() {
    return (
      <Link
        color="primary"
        href="https://help.everyonesocial.app/hc/en-us/articles/4420177186711-Increasing-My-Engagement-and-Reach"
        target="_blank"
      >
        sharing best practices?
      </Link>
    );
  }

  return (
    // the extra single quotes below are necessary for the link to render properly
    <Trans i18nKey="'sharing:publicShareSuccess'" values={{ network: networkTitles[network] }}>
      🎉 &nbsp;Yay! You shared to {{ network }}! Hey, have you checked out our&nbsp;
      {renderSuccessLink()}
    </Trans>
  );
};
export default PublicShareSuccessMessage;
